import styles from "./UserMessages.module.scss"

import React, { memo } from "react"

import { Notice, PowerfulMessage, UserMessagesLayout } from "@shared/components"
import { useChatInfo, useMessagesContext, useSchedule } from "@shared/contexts"

interface Props {
  isActive: boolean
}

function UserMessages({ isActive }: Props) {
  const { isSearchBarEnabled } = useChatInfo()
  const { schedule } = useSchedule()
  const { messages, lastStreamerMessage } = useMessagesContext()

  const scheduleId = schedule?.id

  return (
    <UserMessagesLayout
      isActive={isActive}
      mention={<div className={styles.mentionAlertChatMode} />}
      inner={({ scrollMessages, noticeRef }) => (
        <>
          <Notice
            className="noticeB"
            isActive={!isSearchBarEnabled && Boolean(lastStreamerMessage)}
            noticeRef={noticeRef}
            message={lastStreamerMessage}
          />
          {messages.map((message) => (
            <PowerfulMessage
              key={message.key}
              scrollMessages={scrollMessages}
              message={message}
              scheduleId={scheduleId}
            />
          ))}
        </>
      )}
    />
  )
}

export default memo(UserMessages)
